import { Input as BaseInput } from '@base-ui/react/input'
import styled from 'styled-components'
import { gray } from 'sutra/tokens/colors'

// Used only when an adornment or clear button is present: the border, focus
// ring and size live on this element, and the real <input> inside is bare.
export const Wrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: text;
`

export const InnerInput = styled(BaseInput)`
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  color: inherit;

  &::placeholder {
    color: #a4a7ae;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const Adornment = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  color: ${gray[500]};
`

export const ClearButton = styled.button`
  display: inline-flex;
  flex: none;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: ${gray[400]};
  cursor: pointer;

  &:hover:not(:disabled) {
    color: ${gray[600]};
  }

  &:disabled {
    cursor: not-allowed;
  }
`
